import { render, staticRenderFns } from "./VideoExtended.vue?vue&type=template&id=f6eab466&scoped=true&"
import script from "./VideoExtended.vue?vue&type=script&lang=js&"
export * from "./VideoExtended.vue?vue&type=script&lang=js&"
import style0 from "./VideoExtended.vue?vue&type=style&index=0&id=f6eab466&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6eab466",
  null
  
)

export default component.exports